import React, { useState } from 'react'
import { FileText, ChevronRight, BookOpen, TrendingUp, Menu, X } from 'lucide-react';

const TableOfContent = ({response}:any) => {
  

  const [selectedSection, setSelectedSection] = useState<any>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   const reportData = {
//     metadata: {
//       title: "Investment Management Industry: Trends, Challenges, and Strategic Insights",
//       author: "Your Company Name"
//     },
//     table: [
//       {
//         title: "1. Executive Summary",
//         description: "Overview of key findings and strategic insights"
//       },
//       {
//         title: "2. Industry Overview",
//         description: "Background and context of the global investment management industry"
//       },
//       {
//         title: "3. Industry Landscape",
//         description: "Examination of core participants and the value chain"
//       },
//       {
//         title: "4. Business and Operating Models",
//         description: "Analysis of traditional and outsourced investment management models"
//       },
//       {
//         title: "5. Investment Management Framework",
//         description: "Detailed structure of front, middle, and back-office operations"
//       },
//       {
//         title: "6. Market Trends",
//         description: "Discussion of fee compression, regulatory pressures, and passive investing growth"
//       },
//       {
//         title: "7. ESG and Sustainable Investing",
//         description: "Insights into the growth and challenges of ESG assets"
//       },
//       {
//         title: "8. Technology and Innovation",
//         description: "Impact of AI, machine learning, and automation on investment management"
//       },
//       {
//         title: "9. Key Challenges",
//         description: "Overview of strategic issues such as fee compression and operational resilience"
//       },
//       {
//         title: "10. Conclusion",
//         description: "Final thoughts and recommendations for decision-makers"
//       }
//     ]
//   };

  const getIconForSection = (index: number) => {
  const icons = [
    <FileText key="0" className="w-3 h-3" />,
    <BookOpen key="1" className="w-3 h-3" />,
    <TrendingUp key="2" className="w-3 h-3" />,
    <FileText key="3" className="w-3 h-3" />,
    <BookOpen key="4" className="w-3 h-3" />,
    <TrendingUp key="5" className="w-3 h-3" />,
    <FileText key="6" className="w-3 h-3" />,
    <BookOpen key="7" className="w-3 h-3" />,
    <TrendingUp key="8" className="w-3 h-3" />,
    <FileText key="9" className="w-3 h-3" />
  ];
  return icons[index % icons.length];
};

  return (
    <div className="h-[90vh] max-w-xl border rounded-xl border-gray-300 overflow-y-auto pn_scroller py-3">
       
    <div className="flex items-start gap-2 mb-2 border-b border-gray-400 px-3 pb-3">
        <div className="w-3 h-3 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0">
            <TrendingUp className="w-3 h-3 text-gray-900" />
        </div>
        <div className="flex-1">
            <h2 className="text-sm font-bold text-gray-900">
            {response.metadata.title}
            </h2>
            <p className="text-gray-900 text-sm">
            Comprehensive analysis and strategic insights for investment professionals
            </p>
        </div>
    </div>
     

        {/* Main Content */}
        <div className="grid lg:grid-cols-1 gap-4 px-3">
        
            <div className="bg-white rounded-2xl shadow-lg border border-slate-200  overflow-hidden mb-6">
              <div className="bg-gradient-to-r from-slate-800 to-slate-700 p-2">
                <h3 className="text-lg font-semibold text-white">Table of Contents</h3>
              </div>
              <nav className="p-2 space-y-1 max-h-[calc(100vh-200px)] overflow-y-auto">
                {response.table.map((section:any, index:any) => (
                  <button
                    key={index}
                    onClick={() => setSelectedSection(index)}
                    className={`w-full text-left p-2 rounded-lg transition-all duration-200 flex items-center space-x-3 group ${
                      selectedSection === index
                        ? 'bg-blue-50 border-l-4 border-blue-600'
                        : 'hover:bg-slate-50 border-l-4 border-transparent'
                    }`}
                  >
                    <div className={`flex-shrink-0 ${
                      selectedSection === index ? 'text-blue-600' : 'text-slate-400 group-hover:text-slate-600'
                    }`}>
                      {getIconForSection(index)}
                    </div>
                    <span className={`text-sm font-medium flex-1 ${
                      selectedSection === index ? 'text-blue-900' : 'text-slate-700'
                    }`}>
                      {section.title}
                    </span>
                    {/* <ChevronRight className={`w-4 h-4 flex-shrink-0 transition-transform ${
                      selectedSection === index 
                        ? 'text-blue-600 transform translate-x-1' 
                        : 'text-slate-400 opacity-0 group-hover:opacity-100'
                    }`} /> */}
                  </button>
                ))}
              </nav>
            </div>
        

        </div>
    

      {/* Footer */}
      <footer className="bg-white border-t border-slate-200 mt-16">
        <div className="max-w-7xl mx-auto p-2">
          <div className="text-center text-sm text-slate-600">
            <p>© 2025 {response.metadata.author}. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TableOfContent